export const loadFile = async (url: string) => {
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const fileName = url.split("/").pop();
    return new File(
      [blob],
      fileName === undefined ? "tutorial-sample.mp3" : fileName,
      { type: "audio/mp3" }
    );
  } catch (err) {
    console.error("Failed to load audio file:", err);
    throw err;
  }
};
